import styled, { theme } from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React from 'react'

import { margins } from '../../styles/margins'
import { Icon } from '../icons'
import { StickyHeader } from '.'
import { StickyHeaderDefaultProps, StickyHeaderPropTypes } from './StickyHeader'

const Header = styled.header`
  background-color: ${p =>
    p.background === 'transparent'
      ? 'transparent'
      : theme(`colors.${p.background}`)};
  color: ${p => theme(`colors.${p.color}`)};
  display: flex;
  justify-content: space-between;
  height: 65px;
  ${p => p.theme.media.min.md`
    padding-left: ${rem(20)};
    height: auto;
  `}
`
const ButtonLink = styled.a`
  border: none;
  color: inherit;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-size: ${rem(14)};
  ${p => p.theme.media.min.md`
    margin-bottom: 0;
  `}
    :hover {
    color: inherit;
  }
`
const HeaderItem = styled(ButtonLink)`
  padding: ${rem(margins.s)};
  display: flex;
  align-items: center;
  justify-content: center;
`
const Flip = styled.div`
  display: inline-block;
  transform: rotate(180deg);
  padding-top: ${rem(5)};
  margin-left: ${rem(5)};
  margin-top: 1px;
`
const ShowMobile = styled.div`
  height: 100%;
  margin-top: -${rem(3)};
  ${p => p.theme.media.min.md`
    display: none
  `}
`
const ShowDesktop = styled.div`
  display: none;
  ${p => p.theme.media.min.md`
    padding-top: 5px;
    display: block;
  `};
`

const BrandHeader = ({ background, fixed, fixedOffset }) => {
  const color = background === 'primary' ? 'white' : 'primary'
  return (
    <StickyHeader fixed={fixed} fixedOffset={fixedOffset}>
      <Header background="primary" color={color}>
        <HeaderItem href="/" target="_blank">
          <ShowMobile>
            <Icon name="logo" width="69px" height="31px" />
          </ShowMobile>
          <ShowDesktop>
            <Icon name="logo" width="100px" />
          </ShowDesktop>
        </HeaderItem>
        <HeaderItem href="/" target="_blank">
          To magnet.co.uk{' '}
          <Flip>
            <Icon name="chevron-left" width="12px" height="12px" />
          </Flip>
        </HeaderItem>
      </Header>
    </StickyHeader>
  )
}

const { children, ...stickyHeaderPropTypes } = StickyHeaderPropTypes

BrandHeader.defaultProps = {
  ...StickyHeaderDefaultProps,
  background: 'primary',
}

BrandHeader.propTypes = {
  ...stickyHeaderPropTypes,
  background: PropTypes.oneOf(['primary', 'white', 'transparent']),
}

export default BrandHeader
